import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
// Bootstrap component
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import { processResponse, stringFormat, numberFormat } from '../../../utilities/processResponse'

import SummaryCompleteSection from '../Section/SummaryCompleteSection'
import SubmissionModal from '../SubmissionModal/SubmissionModal';

import { loadingSpinner } from '../../../actions/SurveyAction';

// Assets
import './SurveyCompletePage.css';

 class SummaryCompletedPage extends Component {
    state = {
        show:false
    }

    handleOpen = () => {
        this.setState({show:true});
    }

    handleClose = () => {
        this.setState({show:false});
    }

    handleFinalAsSubmitButton = () => {
        const { dispatch, itemResponses } = this.props;

        if (Object.keys(itemResponses).length !== 0) {
            dispatch(loadingSpinner(true));
            this.props.handleFinalAsSubmitButton(null, null, null, "FinalSubmit");
        }
    }

    render() {
        const {
            totalQuestionCount,
            isRequiredCount,
            answeredQuestion,
            unAnsweredCount,
            naCount,
            pageInstrumentConfiguration,
        } = this.props;

        const {
            properties,
            summaryPage,
            buttons,
            sections,
            submissionModal,
            suppressSaveForLater,
            inactiveButtonCssClass
        } = pageInstrumentConfiguration;

        const {
            key,
            pagePreSectionKey,
            pagePostSectionKey,
            preSummarySectionKey,
            postSummaryForCompletedSectionKey,
            postSummaryForUnansweredUnrequiredSectionKey,
            postSummaryForUnansweredRequiredSectionKey,
            completedFormatStringPropertyKey,
            naFormatStringPropertyKey,
            unansweredFormatStringPropertyKey,
            requiredFormatStringPropertyKey,
            reviewCompletedButtonKey,
            reviewUnansweredButtonKey,
            reviewAllResponsesButtonKey,
            submitAsFinalButtonKey,
            saveForLaterWorkButtonKey,
            pageCssClass
        } = summaryPage;

        const {
            summaryPageAreOrIsPluralForm,
            summaryPageAreOrIsSingularForm,
        } = properties;

        var convertStringFormat = sections.hasOwnProperty(preSummarySectionKey) ? processResponse(sections[preSummarySectionKey].content) : null;

        const answeredCompleteFormatString = numberFormat(properties[completedFormatStringPropertyKey], answeredQuestion, summaryPageAreOrIsSingularForm, summaryPageAreOrIsPluralForm);
        const unansweredCompleteFormatString = numberFormat(properties[unansweredFormatStringPropertyKey], unAnsweredCount, summaryPageAreOrIsSingularForm, summaryPageAreOrIsPluralForm);
        const naCompleteFormatString = numberFormat(properties[naFormatStringPropertyKey], unAnsweredCount, summaryPageAreOrIsSingularForm, summaryPageAreOrIsPluralForm);
        const requiredCompleteFormatString = numberFormat(properties[requiredFormatStringPropertyKey], isRequiredCount, summaryPageAreOrIsSingularForm, summaryPageAreOrIsPluralForm);

        return (
            <Fragment>
                <SubmissionModal
                    active={this.state.show}
                    secondChance={this.props.secondChance}
                    isRequiredCount={isRequiredCount}
                    pageInstrumentConfiguration={pageInstrumentConfiguration}
                    closeSubmissionModal={() => this.handleClose()}
                    handleFinalAsSubmitButton={() => this.props.handleFinalAsSubmitButton(null, null, null, "FinalSubmit") }
                />
                {sections.hasOwnProperty(pagePreSectionKey) ?
                    <SummaryCompleteSection
                        key={sections[pagePreSectionKey].key}
                        type='pre'
                        html={sections[pagePreSectionKey].content}
                        className={sections[pagePreSectionKey].className}
                    /> :null}
                <Container key={key} className={pageCssClass}>
                    {sections.hasOwnProperty(preSummarySectionKey) ?
                    <Row>
                        <Col md="2"></Col>
                        <Col md="8" className={sections[preSummarySectionKey].className} >
                            <div
                                key={sections[preSummarySectionKey].key}
                                type='pre'
                                dangerouslySetInnerHTML={{__html:stringFormat(convertStringFormat, answeredQuestion, totalQuestionCount, summaryPageAreOrIsSingularForm, summaryPageAreOrIsPluralForm)}}
                            >
                            </div>
                        </Col>
                        <Col md="2"></Col>
                    </Row>:null}
                    <Row>
                        <Col md="4"></Col>
                        <Col md="4" className="text-center">
                            {answeredQuestion === totalQuestionCount ?
                                submitAsFinalButtonKey !== null && buttons.hasOwnProperty(submitAsFinalButtonKey) && buttons[submitAsFinalButtonKey].buttonOption !== 0 ?
                                <Button
                                    key={buttons[submitAsFinalButtonKey].key}
                                    className={Object.keys(this.props.itemResponses).length !== 0 ? `_SummaryPageSubmitAsFinalButton ${buttons[submitAsFinalButtonKey].buttonCssClass}`: `_InactiveButton ${inactiveButtonCssClass}`}
                                    onClick={() => this.handleFinalAsSubmitButton()}
                                >
                                    {buttons[submitAsFinalButtonKey].buttonText}
                                </Button>: null:
                                submitAsFinalButtonKey !== null && buttons.hasOwnProperty(submitAsFinalButtonKey) && buttons[submitAsFinalButtonKey].buttonOption !== 0 ?
                                <Button
                                    key={buttons[submitAsFinalButtonKey].key}
                                    className={`_InactiveButton ${inactiveButtonCssClass}`}
                                    onClick={() => this.handleOpen()}
                                >
                                    {buttons[submitAsFinalButtonKey].buttonText}
                            </Button>:null}
                        </Col>
                        <Col md="4"></Col>
                    </Row>
                    <Row>
                        <Col md="3"></Col>
                        <Col md="6" className="text-center">
                           <Row>
                               <Col md="6" className="card-content">
                                    <Card className="text-left">
                                        <Card.Body>
                                            <Card.Title className="text-center">
                                                <span className="circle-success"></span>
                                            </Card.Title>
                                            <Card.Text className="text-center card-success-label">
                                                <div dangerouslySetInnerHTML={{__html:processResponse(answeredCompleteFormatString)}}></div>
                                            </Card.Text>
                                            <Card.Text className="text-center card-na-label">
                                                {naCount !== 0 ? <div dangerouslySetInnerHTML={{__html:processResponse(naCompleteFormatString)}}></div>:null}
                                            </Card.Text>
                                        </Card.Body>
                                        {reviewCompletedButtonKey !== null && buttons.hasOwnProperty(reviewCompletedButtonKey) && buttons[reviewCompletedButtonKey].buttonOption !== 0 ?
                                        <Card.Text
                                            key={buttons[reviewCompletedButtonKey].key}
                                            className={`text-center _SummaryPageReviewCompletedResponsesButton ${buttons[reviewCompletedButtonKey].buttonCssClass}`}
                                        >
                                            <strong
                                                className={`_SummaryPageReviewCompletedResponsesButton ${buttons[reviewCompletedButtonKey].buttonCssClass}`}
                                                onClick={() => this.props.openModal("answered", true)}
                                            >
                                                {buttons[reviewCompletedButtonKey].buttonText}
                                            </strong>
                                        </Card.Text>: null}
                                    </Card>
                               </Col>
                               <Col md="6" className="card-content">
                                    <Card className="text-left">
                                        <Card.Body>
                                            <Card.Title className="text-center">
                                                <span className={ isRequiredCount !== 0 ? "circle-required" : "circle-danger"}></span>
                                            </Card.Title>
                                            <Card.Text className="text-center card-unanswered-label">
                                                {/* <strong>{unAnsweredCount || 0}</strong> {summaryPageAreOrIsPluralForm} <strong>unanswered</strong> */}
                                                <div dangerouslySetInnerHTML={{__html:processResponse(unansweredCompleteFormatString)}}></div>

                                            </Card.Text>
                                            <Card.Text className="text-center card-required-label">
                                                {/* <strong>{ isRequiredCount !== 0 ? isRequiredCount: null}</strong>
                                                { isRequiredCount !== 0 ? " is ": null}<strong>{ isRequiredCount !== 0 ? " required": null}</strong> */}
                                                {isRequiredCount !== 0 ? <div dangerouslySetInnerHTML={{__html:processResponse(requiredCompleteFormatString)}}></div>:null }
                                            </Card.Text>
                                        </Card.Body>
                                        {reviewUnansweredButtonKey !== null && buttons.hasOwnProperty(reviewUnansweredButtonKey) && buttons[reviewUnansweredButtonKey].buttonOption !== 0 ? <Card.Text
                                            key={buttons[reviewUnansweredButtonKey].key}
                                            className={`text-center _SummaryPageReviewUnansweredResponsesButton ${buttons[reviewUnansweredButtonKey].buttonCssClass}`}
                                        >
                                            {answeredQuestion !== totalQuestionCount ?
                                            <strong
                                                className={`_SummaryPageReviewUnansweredResponsesButton ${buttons[reviewUnansweredButtonKey].buttonCssClass}`}
                                                onClick={() => this.props.openModal("unanswered", true)}
                                            >
                                                {buttons[reviewUnansweredButtonKey].buttonText}
                                            </strong> :null}
                                        </Card.Text>:null}
                                    </Card>
                               </Col>
                           </Row>
                        </Col>
                        <Col md="3"></Col>
                    </Row>
                    <Row>
                        <Col md="2"></Col>
                            <Col md="8" className={`text-center`}>
                            {isRequiredCount !== 0 ?
                                sections.hasOwnProperty(postSummaryForUnansweredRequiredSectionKey) ? <div
                                    key={sections[postSummaryForUnansweredRequiredSectionKey].key}
                                    dangerouslySetInnerHTML={{__html:processResponse(sections[postSummaryForUnansweredRequiredSectionKey].content)}}
                                    className={`_SummaryPagePostSummaryForUnansweredRequiredSection ${sections[postSummaryForUnansweredRequiredSectionKey].className}`}
                                ></div>: null :
                                unAnsweredCount === 0 ?
                                sections.hasOwnProperty(postSummaryForCompletedSectionKey) ? <div
                                    key={sections[postSummaryForCompletedSectionKey].key}
                                    dangerouslySetInnerHTML={{__html:processResponse(sections[postSummaryForCompletedSectionKey].content)}}
                                    className={`_SummaryPagePostSummaryForCompletedSection ${sections[postSummaryForCompletedSectionKey].className}`}
                                >
                                </div>:null:
                                unAnsweredCount !== answeredQuestion ?
                                sections.hasOwnProperty(postSummaryForUnansweredUnrequiredSectionKey) ? <div
                                        key={sections[postSummaryForUnansweredUnrequiredSectionKey].key}
                                        dangerouslySetInnerHTML={{__html:processResponse(sections[postSummaryForUnansweredUnrequiredSectionKey].content)}}
                                        className={`_SummaryPagePostSummaryForUnansweredUnrequiredSection ${sections[postSummaryForUnansweredUnrequiredSectionKey].className}`}
                                    ></div>:null
                                :null
                            }
                            </Col>
                        <Col md="2"></Col>
                    </Row>
                    <Row>
                        <Col md="3"></Col>
                            <Col md="6" className="text-center">
                                {answeredQuestion !== totalQuestionCount && reviewAllResponsesButtonKey !== null && buttons.hasOwnProperty(reviewAllResponsesButtonKey) && buttons[reviewAllResponsesButtonKey].buttonOption !== 0 ?
                                <Button
                                    key={buttons[reviewAllResponsesButtonKey].key}
                                    className={`_SummaryPageReviewAllResponsesButton ${buttons[reviewAllResponsesButtonKey].buttonCssClass}`}
                                    onClick={() => this.props.openModal("review", false)}>
                                    {buttons[reviewAllResponsesButtonKey].buttonText}
                                </Button> : null}
                            </Col>
                        <Col md="3"></Col>
                    </Row>
                    <Row>
                        <Col md="4"></Col>
                            <Col md="4" className="text-center">
                                {!suppressSaveForLater && saveForLaterWorkButtonKey !== null && buttons.hasOwnProperty(saveForLaterWorkButtonKey) && buttons[saveForLaterWorkButtonKey].buttonOption !== 0 ? <Button
                                    key={buttons[saveForLaterWorkButtonKey].key}
                                    className={`_SummaryPageSaveForLaterWorkButton ${buttons[saveForLaterWorkButtonKey].buttonCssClass}`}
                                    onClick={() => this.props.redirectSavePage()}
                                >
                                    {buttons[saveForLaterWorkButtonKey].buttonText}
                                </Button>:null}
                            </Col>
                        <Col md="4"></Col>
                    </Row>
                    <Row>
                        {sections.hasOwnProperty(pagePostSectionKey)?
                        <SummaryCompleteSection
                            key={sections[pagePostSectionKey].key}
                            type='post'
                            html={sections[pagePostSectionKey].content}
                            className={sections[pagePostSectionKey].className}
                        />:null}
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    itemList:state.survey.itemList,
    instrumentList:state.survey.instrument,
    isLoader:state.survey.isLoader
});

export default connect(mapStateToProps)(SummaryCompletedPage);